var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 155,
    viewBox: "0 0 155 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.3883 35.7678C75.6347 35.7678 36.0662 19.7545 36.0662 0H35.7738C35.7738 15.8106 42.0543 30.9736 53.2339 42.1536C64.4134 53.3335 79.5761 59.6147 95.3868 59.6153C104.873 59.6153 113.971 63.3837 120.679 70.0916C127.388 76.7995 131.156 85.8975 131.156 95.3838C131.158 104.87 127.391 113.97 120.685 120.679C113.978 127.388 104.881 131.158 95.3943 131.16C85.9072 131.162 76.8084 127.395 70.0991 120.688C63.3897 113.982 59.6194 104.884 59.6175 95.398C59.6173 87.569 58.0751 79.8168 55.0789 72.5842C52.0827 65.3513 47.6913 58.7794 42.1553 53.2437C36.6193 47.7081 30.0472 43.317 22.8141 40.3213C15.5811 37.3256 7.82884 35.7839 0 35.7842V36.0744C19.7508 36.0744 35.7641 75.6258 35.7715 95.3831H35.7678C35.7677 107.174 39.2639 118.7 45.8143 128.504C52.3647 138.308 61.6751 145.949 72.5683 150.461C83.4615 154.974 95.4479 156.155 107.013 153.855C118.576 151.555 129.199 145.877 137.537 137.541C145.874 129.204 151.553 118.582 153.854 107.017C156.155 95.4531 154.975 83.4667 150.463 72.573C145.952 61.6795 138.311 52.3684 128.508 45.8172C118.705 39.2659 107.179 35.7687 95.3883 35.7678Z",
    fill: "url(#paint0_linear_206_128)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_206_128",
    x1: 123.535,
    y1: 134.075,
    x2: 33.48,
    y2: 10.385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.295,
    stopColor: "#E73959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.384,
    stopColor: "#E73D58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477,
    stopColor: "#E74955"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.571,
    stopColor: "#E95E51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666,
    stopColor: "#EA7B4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.761,
    stopColor: "#EDA044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.857,
    stopColor: "#EFCE3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.868,
    stopColor: "#F0D43A"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo4);
export default __webpack_public_path__ + "static/media/logo4.939b070516e1b55621cd261d5054875d.svg";
export { ForwardRef as ReactComponent };